import React, { useEffect } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import DataServices from '../../Services/DataServices';
import ChartWebSocket from '../../WebSockets/ChartWebSocket';

export const RoutesChart = () => {
    const [response, setResponse] = React.useState([]);
    let onWsMessageReceived = (msg) => {
      setResponse(msg.routesSeverity);
    }
    const retrieveData = () => {
        DataServices.getRouteSeverity()
        .then((response) => {
          console.log('response from getRouteSeverity: '+JSON.stringify(response.data.data));
          setResponse(response.data.data);
        })
        .catch((e) => {
          console.log(e);
        });
    };
    useEffect(() => {
      retrieveData()
    }, [])
    return (
        <div style={{ height: 70 }}>
            <ResponsiveBar
                data={response}
                keys={[ 'critical', 'moderate', 'clean' ]}
                indexBy="name"
                margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
                layout="vertical"
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                colors={['#e25d47','#f4ca60','#97e3d5']}
                padding={"0.5"}
                innerPadding={"5px"}
                enableLabel={false}
                theme={{
                  textColor: 'white',
                  tooltip: {
                    container: {
                      color: 'black',
                      background: 'white',
                    },
                  },
                }}
                borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
                labelSkipWidth={17}
                labelSkipHeight={12}
                labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 5.6 ] ] }}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                enableGridX={false}
                enableGridY={false}
            />
        <ChartWebSocket onChange={onWsMessageReceived} />
        </div>
    )
}
